import { put } from 'redux-saga/effects';

import { BrainBoostActions } from '@maggie/store/brain-boost/actions';

export function* handleDidNavigateToBrainBoost() {
  yield put(BrainBoostActions.fetchBrainBoostSession());
}
